import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-arrows-h-icon',
  templateUrl: './navigation-arrows-h.component.html'
})
export class NavigationArrowsHComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
